import { useEffect, useState } from "react";
import EditTurn from "../others/editTurn";
import EliminarModal from "../../components/others/EliminarModal";
import LavorisService from "../../services/LavorisService";
import { TEmployeeApplicantPatient } from "./Turnos.type";
import { TableActions } from "../../components/others/TableActions";
import { useSearchParams } from "react-router-dom";
import { useModal } from "../../hooks";
import { DetailTurnWithDate } from "../others/detailsTurn";
import { PhoneNumber } from "../../utils/phoneNumber";
import moment from "moment";
import { filterMoldeExamPractice } from "../../utils/filterMoldeExamPractice";
import { useSelector } from "react-redux";
import { RootState } from "../../store/combineReducer";
import EditPrestadorTurn from "../others/editTurn/editTurnPrestador";
import { useAlert } from "../../hooks/useAlert";
import GetFollowUpMessages from "../others/GetFollowUps/getFollowUpMessage";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import InfoOffcanvas from '../../components/others/InfoOffCanvas/InfoOffCanvas';
import { getErrorMessage } from "../../utils";
import "./turns_requested.scss";

const VIEW_APPOINTMENTS_MODAL = "viewAppointmentsModal";
const DELETE_APPOINTMENT_MODAL = "deleteAppointmentModal";
const EDIT_APPOINTMENT_MODAL = "editAppointmentModal";
const EDIT_PRESTADOR_APPOINTMENT_MODAL = "editpPrestadorAppointmentModal";
const VIEW_APPOINTMENT_FOLLOW_UP = 'viewAppointmentFollowUpModal';

const TurnsRequested = () => {
  const [from, setFrom] = useState<string>(moment().format('DD/MM/YYYY'));
  const [to, setTo] = useState<string>(moment().format('DD/MM/YYYY'));
  const reduxStore = useSelector((state: RootState) => state.user);
  const chosenRole: string = reduxStore?.currentRole;
  const [chosenAppointment, setChosenAppointment] = useState<TEmployeeApplicantPatient>();
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const LavorisInstance = LavorisService.getInstance();
  const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0].id);
  const { closeModal, openModal, isActive } = useModal();
  const { showAlert } = useAlert();
  const [items, setItems] = useState({
    itemsPerPage: 20,
    page: 1,
  });
  const [data, setData] = useState<any[]>([]);
  const [loader, setLoader] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams("");
  const controller = new AbortController();
  const signal = controller.signal;

  const getAllAppointmentsCall = async () => {
    setLoader(true);
    try {
      const app = await LavorisInstance.TurnServices.getAppointmentsRequestedByCompanyId(
        currentCompany,
        items.itemsPerPage,
        items.page,
        from,
        to,
        signal,
        "",
        ['Solicitado'],
        chosenRole === 'CANDIDATE_APPOINTMENTS' ? true : false
      );

      if (app.length === 0) {
        setHasMore(false);
        return;
      }

      const existingIds = new Set(data?.map(item => item.id));
      const uniqueAppointments = app?.filter(appointment => !existingIds.has(appointment.id));

      setData(prevData => [...prevData, ...uniqueAppointments]);
      setItems(prev => ({ ...prev, page: prev.page + 1 }));
    } catch (e) {
      console.log(e);
      setHasMore(false);
    } finally {
      setLoader(false);
    }
  };

  const getAllAppointmentsRefresh = async () => {
    setRefreshing(true);
    try {
      setItems({
        itemsPerPage: 20,
        page: 1
      });

      const app = await LavorisInstance.TurnServices.getAppointmentsRequestedByCompanyId(
        currentCompany,
        20,
        1,
        from,
        to,
        signal,
        "",
        ['Solicitado'],
        chosenRole === 'CANDIDATE_APPOINTMENTS' ? true : false
      );

      if (app.length === 0) {
        setHasMore(false);
        setData([]);
        return;
      }

      setData(app);
      setItems(prev => ({ ...prev, page: 2 }));
      setHasMore(true);
      showAlert("Datos actualizados correctamente");
    } catch (e) {
      console.log(e);
      setHasMore(false);
      showAlert("Error al actualizar los datos");
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    getAllAppointmentsCall();
  }, []);

  useEffect(() => {
    return () => {
      controller.abort();
    };
  }, []);

  const HandleDeletion = async () => {
    setIsLoading(true);
    try {
      let turnID: any = searchParams.get("rowId");
      await LavorisInstance.TurnServices.DeleteTurn(turnID);
      await getAllAppointmentsRefresh();
      closeModal(DELETE_APPOINTMENT_MODAL);
      showAlert("Turno eliminado correctamente");
    } catch (e) {
      console.log(e);
      showAlert(getErrorMessage({ title: 'No se pudo eliminar el turno' + e, err: e }));
    } finally {
      setIsLoading(false);
    }
  };

  // Configuración de columnas para la tabla
  const requestedTurnsColumns = [
    {
      key: 'patient_name',
      title: 'Apellido y Nombre',
      className: 'col-patient-name-requested',
      expandable: false,
      render: (value: any, row: any) => (
        <div className="patient-name-cell">
          {row?.patient?.name?.toUpperCase() || "---"}
        </div>
      )
    },
    {
      key: 'patient_dni',
      title: 'DNI',
      className: 'col-dni-requested',
      responsive: 'tablet' as const,
      expandable: false,
      render: (value: any, row: any) => row?.patient?.DNI || "---"
    },
    {
      key: 'patient_phone',
      title: 'Teléfono',
      className: 'col-phone-requested',
      responsive: 'desktop' as const,
      expandable: false,
      render: (value: any, row: any) => (
        <div className="phone-cell">
          {PhoneNumber(row?.patient?.phoneNumber) || "---"}
        </div>
      )
    },
    {
      key: 'patient_email',
      title: 'Email',
      className: 'col-email-requested',
      expandable: false,
      render: (value: any, row: any) => (
        <div className="email-cell">
          {row?.patient?.email?.toLowerCase() || "---"}
        </div>
      )
    },
    {
      key: 'created_date',
      title: 'Fecha de solicitud',
      className: 'col-created-date-requested',
      expandable: false,
      render: (value: any, row: any) => (
        <div className="date-cell">
          {moment(row.createdDate).format('DD/MM/YYYY') || "---"}
        </div>
      )
    },
    {
      key: 'status',
      title: 'Estado',
      className: 'col-status-requested',
      expandable: false,
      render: (value: any, row: any) => (
        <div className="status-cell">
          <span className={`status-badge ${row.status?.toLowerCase().replace(/\s+/g, '-')}`}>
            {row.status}
          </span>
        </div>
      )
    },
    {
      key: 'description',
      title: 'Descripción',
      className: 'col-description-requested',
      expandable: false,
      render: (value: any, row: any) => (
        <div className="description-cell">
          {filterMoldeExamPractice(row) || "---"}
        </div>
      )
    },
    {
      key: 'actions',
      title: 'Acciones',
      className: 'col-actions-requested',
      expandable: false,
      fixed: false,
      render: (value: any, row: any) => (
        <div className="flex flex-wrap gap-2 justify-center">
          <TableActions
            type="View"
            onClick={() => openModal(VIEW_APPOINTMENTS_MODAL, row.id)}
          />

          {row.status === 'Solicitado' && (
            <>
              <TableActions
                type='Messages'
                color={row.appointment_follow_up.length > 0 ? 'orange' : 'blue'}
                title={row.appointment_follow_up.length > 0 ? 'Ver mensajes de gestión' : 'No hay mensajes de gestión'}
                onClick={() => openModal(VIEW_APPOINTMENT_FOLLOW_UP, row.id)}
              />
              <TableActions
                type="Edit"
                onClick={() => {
                  setItems({ itemsPerPage: 20, page: 1 });
                  setChosenAppointment(row.patient);
                  row.is_prestador
                    ? openModal(EDIT_PRESTADOR_APPOINTMENT_MODAL, row.id)
                    : openModal(EDIT_APPOINTMENT_MODAL, row.id);
                }}
              />
              <TableActions
                type="Delete"
                onClick={() => {
                  setItems({ itemsPerPage: 20, page: 1 });
                  setChosenAppointment(row.patient);
                  openModal(DELETE_APPOINTMENT_MODAL, row.id);
                }}
              />
            </>
          )}
        </div>
      )
    }
  ];

  // Ordenar datos de más antiguo a más nuevo
  const sortedData = [...data].sort((a, b) => {
    return new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime();
  });

  return (
    <>
      {/* Header Section */}
      <div className="turns-requested-header">
        <div className="header-top">
          <h5 className="section-title">Solicitudes de Turnos</h5>
          <InfoOffcanvas title="INFORMACIÓN DE TABLA">
            <ul>
              <li><strong>Estado:</strong> Muestra solo los turnos con estado "Solicitado"</li>
              <li><strong>Ordenamiento:</strong> Se ordena de lo más antiguo a lo más nuevo</li>
              <li><strong>Edición:</strong> Mientras el turno tenga estado "Solicitado", puede ser editado o eliminado</li>
              <li><strong>Acciones disponibles:</strong> Ver detalles, mensajes de gestión, editar y eliminar</li>
              <li>A medida que se va haciendo scroll para abajo, la tabla va buscando más resultados</li>
              <li>Use el botón de actualizar para obtener los datos más recientes</li>
            </ul>
          </InfoOffcanvas>
        </div>

        <div className="header-controls">
          {/* Results Count */}
          <div className="results-count">
            <span className="count-number">{data.length}</span>
            <span className="count-label">solicitudes</span>
          </div>

          {/* Refresh Button */}
          <button
            className="refresh-btn"
            onClick={getAllAppointmentsRefresh}
            title="Actualizar tabla"
            disabled={refreshing || loader}
          >
            {refreshing ? (
              <div className="loading-spinner">
                <div className="spinner"></div>
              </div>
            ) : (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M13.65 2.35C12.2 0.9 10.21 0 8 0 3.58 0 0 3.58 0 8s3.58 8 8 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L9 5h7V-2l-2.35 2.35z"
                  fill="currentColor"
                />
              </svg>
            )}
            <span className="btn-text">Actualizar</span>
          </button>

          {/* Loading Indicator */}
          {loader && (
            <div className="loading-indicator">
              <div className="loading-spinner">
                <div className="spinner"></div>
              </div>
              <span>Cargando...</span>
            </div>
          )}
        </div>
      </div>

      {/* Table Section */}
      <InfiniteTable
        data={sortedData}
        columns={requestedTurnsColumns}
        loading={loader}
        hasMore={hasMore}
        onLoadMore={getAllAppointmentsCall}
        height={470}
        emptyMessage="Momentáneamente no hay solicitudes de turnos cargadas para mostrar"
        loadingMessage={data.length === 0 ? "Cargando solicitudes..." : "Buscando más solicitudes..."}
        striped
        hover
        bordered
      />

      {/* Modals */}
      {isActive(DELETE_APPOINTMENT_MODAL) && (
        <EliminarModal
          toggleModal={true}
          name={chosenAppointment?.name || ""}
          isLoading={isLoading}
          handleDeletion={HandleDeletion}
          urlTittle={DELETE_APPOINTMENT_MODAL}
          onClose={() => closeModal(DELETE_APPOINTMENT_MODAL)}
        />
      )}

      {isActive(EDIT_APPOINTMENT_MODAL) && (
        <EditTurn
          toggleModal
          urlTittle={EDIT_APPOINTMENT_MODAL}
          patient={chosenAppointment}
          refreshFunction={() => {
            closeModal(EDIT_APPOINTMENT_MODAL);
            getAllAppointmentsRefresh();
          }}
          onClose={() => closeModal(EDIT_APPOINTMENT_MODAL)}
          isApplicant={true}
        />
      )}

      {isActive(EDIT_PRESTADOR_APPOINTMENT_MODAL) && (
        <EditPrestadorTurn
          toggleModal
          urlTittle={EDIT_PRESTADOR_APPOINTMENT_MODAL}
          patient={chosenAppointment}
          onClose={() => closeModal(EDIT_PRESTADOR_APPOINTMENT_MODAL)}
          isApplicant={true}
          refreshFunction={() => {
            closeModal(EDIT_PRESTADOR_APPOINTMENT_MODAL);
            getAllAppointmentsRefresh();
          }}
        />
      )}

      {isActive(VIEW_APPOINTMENTS_MODAL) && (
        <DetailTurnWithDate
          show
          modalTitle={"Detalle de turno"}
          urlTittle={VIEW_APPOINTMENTS_MODAL}
          closeModal={() => closeModal(VIEW_APPOINTMENTS_MODAL)}
        />
      )}

      {isActive(VIEW_APPOINTMENT_FOLLOW_UP) && (
        <GetFollowUpMessages
          show
          urlTittle={VIEW_APPOINTMENT_FOLLOW_UP}
          onClose={() => closeModal(VIEW_APPOINTMENT_FOLLOW_UP)}
          modalTitle="VER MENSAJES DE GESTIÓN"
        />
      )}
    </>
  );
};

export default TurnsRequested;